/**
 * Client-side checks aligned with useCreateProduct / admin expectations.
 * Returns human-readable field labels for notifications.
 */

import { descriptionPlainForValidation } from '../../utils/productDescriptionHtml';

export function getMissingFieldsForCreate(productData, imageFiles) {
  const missing = [];

  if (!productData.name || String(productData.name).trim() === '') {
    missing.push('Product name');
  }
  const descPlain = descriptionPlainForValidation(productData.description);
  if (!descPlain || String(descPlain).trim() === '') {
    missing.push('Description');
  }
  if (!productData.brand || String(productData.brand).trim() === '') {
    missing.push('Brand');
  }
  if (!productData.category || String(productData.category).trim() === '') {
    missing.push('Category');
  }

  const price = parseFloat(String(productData.price));
  if (
    productData.price === undefined ||
    productData.price === null ||
    productData.price === '' ||
    Number.isNaN(price) ||
    price <= 0
  ) {
    missing.push('Original price');
  }

  if (!imageFiles || imageFiles.length === 0) {
    missing.push('At least one product image');
  }

  return missing;
}

/** Same core fields when updating (images optional — existing URLs may apply). */
export function getMissingFieldsForUpdate(productData) {
  const missing = [];

  if (!productData.name || String(productData.name).trim() === '') {
    missing.push('Product name');
  }
  const descPlainUp = descriptionPlainForValidation(productData.description);
  if (!descPlainUp || String(descPlainUp).trim() === '') {
    missing.push('Description');
  }
  if (!productData.brand || String(productData.brand).trim() === '') {
    missing.push('Brand');
  }
  if (!productData.category || String(productData.category).trim() === '') {
    missing.push('Category');
  }

  const price = parseFloat(String(productData.price));
  if (
    productData.price === undefined ||
    productData.price === null ||
    productData.price === '' ||
    Number.isNaN(price) ||
    price <= 0
  ) {
    missing.push('Original price');
  }

  return missing;
}

export function formatMissingFieldsMessage(missing) {
  if (!missing || missing.length === 0) return '';
  return `Missing: ${missing.join(', ')}`;
}
